<template>
  <div class="ys_apply">
    <div v-if="!pupopShow" class="yssq_table">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex; height: 39px"
            :model="searchForm"
            label-width="90px"
            label-position="left"
          >
            <el-form-item label="许可证编号:" style="">
              <el-input
                v-model="searchForm.xkzBh"
                clearable
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="申请日期:">
              <el-col :span="11">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  clearable
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="2"
              >-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="searchForm.endTime"
                  clearable
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="60px">
              <el-select v-model="searchForm.zt" clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              v-preventReClick
              type="primary"
              class="sousuoButton"
              size="small"
              round
              icon="el-icon-search"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="yssqTable"
            v-loading="loading"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            :cell-style="typeStyle"
            @select="select"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  icon="el-icon-plus"
                  size="mini"
                  @click="addPupShow"
                >申请</el-button>
                <el-button
                  v-preventReClick
                  class="deleteButton"
                  icon="el-icon-plus"
                  size="mini"
                  @click="Fuzhi"
                >复制新增</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  class="deleteButton"
                  icon="el-icon-upload"
                  @click="daochu"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                align="center"
                :show-overflow-tooltip="true"
                :label="item.label"
                :prop="item.key == 'sqsj' ? 'sqsj' : ''"
              >
                <template slot-scope="scope">
                  <span v-if="item.key == 'hzsl'">
                    {{ scope.row.hzsl }}{{ scope.row.hzslDwMc }}
                  </span>
                  <span v-else-if="item.key == 'yxqx'">
                    {{ scope.row.yxqJs }}
                  </span>
                  <span v-else-if="item.key == 'yszType'">
                    {{
                      scope.row.yszType == "1"
                        ? "购买运输"
                        : scope.row.yszType == "2"
                          ? "移库运输"
                          : scope.row.yszType == "3"
                            ? "退货运输"
                            : "多方运输"
                    }}
                  </span>
                  <span v-else>
                    {{ scope.row[item.key] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="250px" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-view"
                    size="mini"
                    style="width: 65px; padding: 7px 9px"
                    @click="query(scope.row.id)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    style="width: 65px; padding: 7px 9px"
                    @click="edit(scope.row.id)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    size="mini"
                    icon="el-icon-close"
                    style="
                      background: #ff4c00;
                      color: #fff;
                      width: 65px;
                      padding: 7px 9px;
                    "
                    class="shanchu"
                    @click="Delete(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt == '12'"
                    v-preventReClick
                    type="primary"
                    size="mini"
                    style="width: 65px; padding: 7px 9px"
                    @click="hexiao(scope.row.id)"
                  >核销</el-button>
                  <el-button
                    v-if="scope.row.zt == '42'"
                    v-preventReClick
                    type="primary"
                    size="mini"
                    style="background: #4170ff; padding: 7px 9px; width: 74px"
                    @click="handlecancel(scope.row.id)"
                  >取消核销</el-button>
                  <el-button
                    v-if="scope.row.zt == '12'"
                    v-preventReClick
                    size="mini"
                    type="primary"
                    style="width: 65px; padding: 7px 9px"
                    @click="handledy(scope.$index, scope.row)"
                  >打印</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <YssqProcess
      v-if="pupopShow"
      ref="yssqProcess"
      :type="leixing"
      :hxBeforeFlag="hxBeforeFlag"
    />
  </div>
</template>
<script>
import { getTableList, excelwriter, Delete } from '@/assets/js/yssq'
import {getkv, getYszWriteOffBefore, downloadPdf } from '@/assets/js/common.js'
import YssqProcess from '@/components/yssq/yssqProcess'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { YssqProcess },
  props: {},
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      loading: true,
      hxBeforeFlag: false,
      pupopShow: false,
      leixing: '',
      content: {},
      titleText: '',
      dialogVisible: false,
      table: [
        {
          key: 'yszType',
          label: '运输证类型'
        },

        {
          key: 'xkzBh',
          label: '许可证编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'hzsl',
          label: '运输数量'
        },
        {
          key: 'fhdwMc',
          label: '发货单位'
        },
        {
          key: 'sqsj',
          label: '申请时间',
          props: 'sqsj'
        },
        {
          key: 'yxqx',
          label: '有效期至'
        },
        {
          key: 'ztMc',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        xkzBh: '',
        beginTime: '',
        endTime: '',
        zt: ''
      },

      multipleSelection: [],
      options: []
    }
  },
  computed: {},
  watch: {},
  created() {
    // 获取运输证列表数据
    this.getTableData()
    if (this.$route.params.id) {
      this.getTableData()
      // this.pupopShow = true;
      // this.leixing = this.$route.params.type;
    }
    getkv('yzd_xkz_zt').then((e) => {
      this.options = e.data.data
    })
  },
  mounted() {
    // if (this.$route.params.id) {
    //   this.pupopShow = true;
    //   this.leixing = "fuzhi";
    //   this.$nextTick(() => {
    //     this.$refs.yssqProcess.queryByID(this.$route.params.id);
    //   });
    // }
  },

  beforeDestroy() {},
  methods: {
    // 搜索
    sousuo() {
      this.getTableData()
    },
    // 取消核销
    handlecancel(id) {
      this.pupopShow = true
      this.leixing = 'qxhx'
      this.$nextTick(() => {
        this.$refs.yssqProcess.queryByID(id)
      })
    },
    // 打印
    handledy(index, row) {
      window.location.href = downloadPdf(row.xkzBh, row.id)
    },
    // 导出
    daochu() {
      excelwriter(this.searchForm).then((e) => {
        const table = '运输证'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 根据状态改变单元格字体颜色
    typeStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 8) {
        switch (row.zt) {
          case '00': // 草稿
            cellStyle = 'color:#333;font-weight:bold '
            break
          case '11': // 审批中
            cellStyle = 'color:#43A4E2;font-weight:bold '
            break
          case '12': // 已通过
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '13': // 不通过
            cellStyle = 'color:red;font-weight:bold '
            break
          case '22': // 已撤销
            cellStyle = 'color:red;font-weight:bold '
            break
          case '42': // 已核销
            cellStyle = 'color:red;font-weight:bold '
            break
          case '43': // 取消核销中
            cellStyle = 'color:red;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    // 删除
    Delete(id) {
      this.$confirm('确认是否删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      })
        .then(() => {
          Delete(id).then(() => {
            this.getTableData()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增
    addPupShow() {
      this.pupopShow = true
      this.leixing = 'add'
    },
    // 草稿状态下编辑
    edit(id) {
      this.pupopShow = true
      this.leixing = 'edit'

      this.$nextTick(() => {
        this.$refs.yssqProcess.queryByID(id)
      })
    },
    // 查看
    query(id) {
      this.pupopShow = true
      this.leixing = 'query'
      this.$nextTick(() => {
        this.$refs.yssqProcess.queryByID(id)
      })
    },
    // 核销
     hexiao(id) {
      this.leixing = 'xkzhx'
      getYszWriteOffBefore(id).then((e) => {
        if (e.data.data) {
          this.hxBeforeFlag = true
        } else {
          this.hxBeforeFlag = false
        }
        this.pupopShow = true
        this.$nextTick(() => {
          this.$refs.yssqProcess.queryByID(id)
        })
      })
    },
    Fuzhi() {
      const id =
        this.$refs.yssqTable.selection.length != 0
          ? this.$refs.yssqTable.selection[0].id
          : null
      const yszType =
        this.$refs.yssqTable.selection.length != 0
          ? this.$refs.yssqTable.selection[0].yszType
          : null
      if (yszType == 3) this.$message.error('退货运输不可复制新增')
      if (id && yszType != 3) {
        this.pupopShow = true
        this.leixing = 'fuzhi'
        this.$nextTick(() => {
          this.$refs.yssqProcess.queryByID(id)
        })
      }
    },

    select(selection, row) {
      this.$refs.yssqTable.clearSelection()
      if (selection.length === 0) {
        // 判断selection是否有值存在
        return
      }
      if (row) {
        this.$refs.yssqTable.toggleRowSelection(row, true)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getTableData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getTableData()
    },
    toggleSelection(rows) {},
    handleSelectionChange(val) {},
    async getTableData() {
        this.pupopShow = false
        this.searchForm.vdata = await dealDataGy()
        getTableList({
            param: this.searchForm,
            page: this.currentPage,
            size: this.pagesize
        }).then((e) => {
            this.loading = false

            this.tableData = e.data.data.rows
            this.total = e.data.data.total
        })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.ys_apply {
  .headerSearch {
    max-width: 1518px;
    height: 96px;
    margin-bottom: 10px;
    margin-top: 35px;
    background-color: white;
    // padding: 30px 0 20px 0;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .yssq_table {
    width: 95%;
    max-width: 1503px;
    // min-width: 1100px;
    margin: auto;
  }
  /deep/.el-table .cell,
  /deep/.el-table--border td:first-child .cell,
  /deep/.el-table--border th:first-child .cell {
    padding-left: 8px !important;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #ebeef5;
    text-align: center;
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-radius: 20px;
      border-color: #4170ff;
    }
    /deep/ .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      // &:last-child {
      //   // width: 90px;
      //   height: 39px;
      // }
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;
      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .el-button--warning {
      color: #fff;
      background: #fe5622;
      border-radius: 3px;
      border-color: #fe5622;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }

    .shanchu {
      border-color: #ff4c00;
      background: #ff4c00;
      color: #fff;
      width: 65px;
      padding: 7px 9px;
    }
  }
  .el-page {
    // width: 90px;
    // height: 39px;
    .el-pager {
      .active {
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
</style>
